import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import blog1 from '../../images/blog-1.jpg'
import blog2 from '../../images/blog-2.jpg'
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import BlogCard from './BlogCard';
import { Button } from 'antd';


SwiperCore.use([Navigation]);

const viewAll = <Button type="primary" >View All</Button>;
const swiperParams = {
    slidesPerView: 1,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 3,
        },
    },
}

function BlogSlider() {
    return (
        <div className="">
            <Swiper
                {...swiperParams}
                navigation={true}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
            >

                <SwiperSlide key="1">
                    <BlogCard imageUrl={blog1} />
                </SwiperSlide>

                <SwiperSlide key="2">
                    <BlogCard imageUrl={blog2} />
                </SwiperSlide>
                
                <SwiperSlide key="3">
                    <BlogCard imageUrl={blog1} />
                </SwiperSlide>

                <SwiperSlide key="4">
                    <BlogCard imageUrl={blog2} />
                </SwiperSlide>

            </Swiper>
            
        </div>
    );
}

export default BlogSlider;
